import React from "react";
import { useUserContext } from "@/contexts/UserContext";
import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";

export function Intercom() {
  const { user } = useUserContext();
  const intercom = useIntercom();

  useEffect(() => {
    if (user && sessionStorage.getItem("show-intercom") === "true") {
      console.log("intercom");
      intercom.update({
        hideDefaultLauncher: false,
      });
    }
  }, [user]);

  return null;
}
